<template>
  <div class="level">
    <qd-collapse class="column is-5 is-paddingless" >
      <div class="columns is-multiline is-marginless subMenu">
        <div class="column is-12 is-paddingless">
          <div class="level-right">
            <button @click="close()" class="button is-subMenu">
              <b-icon icon="close"
                      custom-size="mdi-10px"
                      type="is-white">
              </b-icon>
            </button>
          </div>
          <display-menu-and-sub-menu :menuAndSubMenu="gescomMenu">
          </display-menu-and-sub-menu>
        </div>
      </div>
    </qd-collapse>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { CATEGORIE_REGROUPEMENT_NUMERIQUE, CATEGORIE_ECRAN_NUMERIQUE } from '@/configuration/catalogue/produitConf';
import displayMenuAndSubMenu from '@/components/sideBar/submenuSidebar/displayMenuAndSubMenu';
import * as permBodac from '@/configuration/permissionsBodacConf';
import { SET_GESTCOM_MENU, SET_INDEX_SUB_MENU_OPEN } from '@/store/modules/menu/menu-mutation-type';
import {
  MENU_GESCOM_SALES,
  SOUS_MENU_ECHEANCE_PAIEMENT,
  SOUS_MENU_RETROCESSION,
  MENU_FACTOR,
  MENU_PRODUITS,
  SOUS_MENU_PLAN_MEDIA,
  MENU_OUTLS,
  SOUS_MENU_IMPORT_IDELIA,
  MENU_PRESSE,
  MENU_CAMPAGNE,
  MENU_PLANNING,
  SOUS_MENU_PRODUIT_RESEAU_NUM,
  SOUS_MENU_EDITION_PRODUIT,
  SOUS_MENU_REGROUPEMENT_PRODUIT,
  SOUS_MENU_PROD_ECRAN_NUM,
  SOUS_MENU_PRODUIT_FACE_UNITAIRE,
  SOUS_MENU_PRODUIT_RESEAU_LC,
  SOUS_MENU_PRODUIT_RESEAU_TEMPO,
  SOUS_MENU_PRODUIT_RESEAU_TEMPO_DISPO,
  SOUS_MENU_DEMANDE_TEMPO,
} from '@/configuration/bodac/menuGescom';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import remove from 'lodash/remove';
import messageErreur from '@/services/general/messageErreur';
import { PLAN_MEDIA, PARUTION } from '@/configuration/presse/permissionsPresseConf';

const menu = createNamespacedHelpers('menu');
const Parametres = createNamespacedHelpers('parametres');
const CategorieVente = createNamespacedHelpers('categorieVente');

export default {
  name: 'GestComSubmenu',
  components: {
    displayMenuAndSubMenu,
  },
  data() {
    return {
      gestcom: [
        {
          title: MENU_GESCOM_SALES,
          noSubMenu: false,
          data: [
            { name: 'sidebar.gestCom.quotation', path: 'l.bodac.devis', perm: permBodac.DEVIS.lecture },
            { name: 'sidebar.gestCom.lignesDevis', path: 'l.bodac.devis-liste', perm: permBodac.DEVIS.lecture },
            { name: SOUS_MENU_DEMANDE_TEMPO, path: 'l.bodac.demande_tempo', perm: permBodac.DEMANDE_TEMPO.lecture },
            { name: SOUS_MENU_PLAN_MEDIA, path: 'l.presse.plan_media', perm: PLAN_MEDIA.lecture },
            { name: 'sidebar.gestCom.order', path: 'l.bodac.commandes-liste', perm: permBodac.COMMANDES.lecture },
            { name: 'sidebar.gestCom.lignesCommande', path: 'l.bodac.commandes-lignesCmd', perm: permBodac.COMMANDES.lecture },
            { name: 'sidebar.gestCom.bill', path: 'l.bodac.factures', perm: permBodac.FACTURES.lecture },
            { name: 'sidebar.gestCom.lignesFacture', path: 'l.bodac.factures-lignes', perm: permBodac.FACTURES.lecture },
            { name: SOUS_MENU_ECHEANCE_PAIEMENT, path: 'l.bodac.echeance_payement', perm: permBodac.ECHEANCIER_PAIEMENT.lecture },
            { name: 'sidebar.gestCom.remiseBancaire', path: 'l.bodac.remises_bancaires', perm: permBodac.REMISES_BANCAIRES.lecture },
            { name: 'sidebar.gestCom.journalReglements', path: 'l.bodac.journal_reglements', perm: permBodac.JOURNAL_REGLEMENTS.lecture },
            { name: 'sidebar.gestCom.Relances', path: 'l.bodac.relance-listeDesRetards', perm: permBodac.RELANCE.lecture },
            { name: SOUS_MENU_RETROCESSION, path: 'l.bodac.retrocession', perm: permBodac.JOURNAL_REGLEMENTS.lecture },
          ],
        },
        {
          title: 'sidebar.gestCom.customers',
          noSubMenu: false,
          data: [
            { name: 'sidebar.gestCom.customers', path: 'l.bodac.clients/contacts-clients', perm: permBodac.TIERS.lecture },
            { name: 'sidebar.gestCom.contacts', path: 'l.bodac.clients/contacts-contacts', perm: permBodac.TIERS.lecture },
          ],
        },
        {
          title: MENU_PRODUITS,
          noSubMenu: false,
          data: [
            { name: 'sidebar.gestCom.catalogue', path: 'l.bodac.catalogue', perm: permBodac.CATALOGUE.lecture },
            { name: SOUS_MENU_REGROUPEMENT_PRODUIT, path: 'l.bodac.catalogue-regroupementProduit', perm: permBodac.CATALOGUE.lecture },
          ],
        },
        {
          title: MENU_PLANNING,
          noSubMenu: false,
          data: [
            { name: 'sidebar.gestCom.faceUnitaire', path: 'c.bodac.commandes-faceUnitaire', perm: permBodac.COMMANDES.lecture },
            { name: SOUS_MENU_PRODUIT_RESEAU_TEMPO, path: 'c.bodac.planning-reseauTempo', perm: permBodac.COMMANDES.lecture },
            { name: 'sidebar.gestCom.relanceOption', path: 'l.bodac.relance_option', perm: permBodac.RELANCE_OPTION.lecture },
            { name: SOUS_MENU_PRODUIT_RESEAU_LC, path: 'c.bodac.commandes-planningReseauLc', perm: permBodac.COMMANDES.lecture },
            {
              name: SOUS_MENU_PROD_ECRAN_NUM,
              path: 'c.bodac.commandes-planningNumerique',
              params: { typeProduit: CATEGORIE_ECRAN_NUMERIQUE },
              perm: permBodac.COMMANDES.lecture,
            },
            {
              name: SOUS_MENU_PRODUIT_RESEAU_NUM,
              path: 'c.bodac.commandes-planningNumerique',
              params: { typeProduit: CATEGORIE_REGROUPEMENT_NUMERIQUE },
              perm: permBodac.COMMANDES.lecture,
            },
          ],
        },
        {
          title: MENU_OUTLS,
          noSubMenu: false,
          data: [
            { name: SOUS_MENU_PRODUIT_RESEAU_TEMPO_DISPO, path: 'l.bodac.catalogue-reseauTempoDispo', perm: permBodac.CATALOGUE.lecture },
            { name: 'sidebar.gestCom.cartographie', path: 'l.bodac.catalogue-cartographie', perm: permBodac.CATALOGUE.lecture },
            { name: 'sidebar.gestCom.suiviAffectations', path: 'l.bodac.catalogue-suivi-affectation', perm: permBodac.CATALOGUE.lecture },
            { name: SOUS_MENU_IMPORT_IDELIA, path: 'm.bodac.import-idelia', perm: permBodac.IMPORT.maj },
            { name: SOUS_MENU_EDITION_PRODUIT, path: 'l.bodac.catalogue-presse', perm: permBodac.CATALOGUE.lecture },
          ],
        },
        {
          title: MENU_FACTOR,
          noSubMenu: false,
          data: [
            { name: 'sidebar.gestCom.factor', path: 'l.bodac.factor', perm: permBodac.FACTOR.lecture },
            { name: 'sidebar.gestCom.transmission', path: 'l.bodac.transmission', perm: permBodac.TRANSMISSION.lecture },
          ],
        },
        {
          title: 'sidebar.gestCom.campagne',
          noSubMenu: false,
          data: [
            { name: 'sidebar.gestCom.campagne', path: 'l.bodac.campagne', perm: permBodac.CAMPAGNE.lecture },
          ],
        },
        {
          title: MENU_PRESSE,
          noSubMenu: false,
          data: [
            { name: 'sidebar.gestCom.parution', path: 'l.presse.parution', perm: PARUTION.lecture },
          ],
        },
      ],
      gescomMenu: [],
    };
  },
  methods: {
    ...menu.mapMutations({
      setGestcomMenu: SET_GESTCOM_MENU,
      setIndexSubMenu: SET_INDEX_SUB_MENU_OPEN,
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    close() {
      this.setGestcomMenu(false);
      this.setIndexSubMenu(null);
    },
    getGescomMenu() {
      const tabGescom = this.gestcom;
      const indexMenuGescom = tabGescom
        .findIndex(menu => menu.title === MENU_GESCOM_SALES);
      if (!this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePlanMedia.key)
        && indexMenuGescom !== -1) {
        remove(
          tabGescom[indexMenuGescom].data,
          item => item.name === SOUS_MENU_PLAN_MEDIA,
        );
      }
      if (!this.parametresInterne(PARAMETRES_INTERNE_KEYS.prelevementSepa.key)
       && indexMenuGescom !== -1) {
        remove(
          tabGescom[indexMenuGescom].data,
          item => item.name === SOUS_MENU_ECHEANCE_PAIEMENT,
        );
      }
      if (!this.parametresInterne(PARAMETRES_INTERNE_KEYS.retrocessionAlfa.key)
        && indexMenuGescom !== -1) {
        remove(
          tabGescom[indexMenuGescom].data,
          item => item.name === SOUS_MENU_RETROCESSION,
        );
      }
      const indexMenuFactor = tabGescom.findIndex(menu => menu.title === MENU_FACTOR);
      if (!this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleFactor.key)
        && indexMenuFactor !== -1) {
        remove(tabGescom, menu => menu.title === MENU_FACTOR);
      }

      if (!this.parametresInterne(PARAMETRES_INTERNE_KEYS.importCommandeIdelia.key)) {
        remove(
          tabGescom.find(menu => menu.title === MENU_OUTLS).data,
          item => item.name === SOUS_MENU_IMPORT_IDELIA,
        );
      }
      if (!this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleProduitReseauTempo.key)) {
        remove(
          tabGescom.find(menu => menu.title === MENU_OUTLS).data,
          item => item.name === SOUS_MENU_PRODUIT_RESEAU_TEMPO_DISPO,
        );
        remove(
          tabGescom.find(menu => menu.title === MENU_GESCOM_SALES).data,
          item => item.name === SOUS_MENU_DEMANDE_TEMPO,
        );
      }
      const menuProduit = tabGescom.find(menu => menu.title === MENU_PRODUITS);
      if (menuProduit) {
        menuProduit.data = menuProduit.data.concat(
          this.categorieProduit
            .filter(c => !!c.menu)
            .sort((a, b) => a.menu.ordre - b.menu.ordre)
            .map(c => {
              return {
                name: c.menu?.libelle ?? c.libelle,
                path: c.menu.route,
                perm: permBodac.CATALOGUE.lecture,
                params: c.menu.params,
              };
            }),
        );
      }
      const indexMenuPresse = tabGescom.findIndex(menu => menu.title === MENU_PRESSE);
      if (!this.parametresInterne(PARAMETRES_INTERNE_KEYS.produitPresse.key)
        && indexMenuPresse !== -1) {
        remove(tabGescom, menu => menu.title === MENU_PRESSE);
      }
      const indexMenuCampagne = tabGescom.findIndex(menu => menu.title === MENU_CAMPAGNE);
      if (!this.parametresInterne(PARAMETRES_INTERNE_KEYS.campagne.key)
        && indexMenuCampagne !== -1) {
        remove(tabGescom, menu => menu.title === MENU_CAMPAGNE);
      }
      if (!this.afficherMenuEditionProduit) {
        remove(
          tabGescom.find(menu => menu.title === MENU_OUTLS).data,
          item => item.name === SOUS_MENU_EDITION_PRODUIT,
        );
      }
      if (!this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleRegroupementProduit.key)) {
        remove(
          tabGescom.find(menu => menu.title === MENU_PRODUITS).data,
          item => item.name === SOUS_MENU_REGROUPEMENT_PRODUIT,
        );
      }
      if (!this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleProduitReseauNumerique.key)) {
        remove(
          tabGescom.find(menu => menu.title === MENU_PLANNING).data,
          item => item.name === SOUS_MENU_PRODUIT_RESEAU_NUM,
        );
      }
      if (!this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleEcranNumerique.key)) {
        remove(
          tabGescom.find(menu => menu.title === MENU_PLANNING).data,
          item => item.name === SOUS_MENU_PROD_ECRAN_NUM,
        );
      }
      if (!this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleProduitFaceUnitaire.key)) {
        remove(
          tabGescom.find(menu => menu.title === MENU_PLANNING).data,
          item => item.name === SOUS_MENU_PRODUIT_FACE_UNITAIRE,
        );
      }
      if (!this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleProduitReseauLc.key)) {
        remove(
          tabGescom.find(menu => menu.title === MENU_PLANNING).data,
          item => item.name === SOUS_MENU_PRODUIT_RESEAU_LC,
        );
      }
      if (!this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleProduitReseauTempo.key)) {
        remove(
          tabGescom.find(menu => menu.title === MENU_PLANNING).data,
          item => item.name === SOUS_MENU_PRODUIT_RESEAU_TEMPO,
        );
      }
      return tabGescom;
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...CategorieVente.mapGetters({
      categorieProduit: 'categorieProduit',
    }),
    afficherMenuEditionProduit() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.produitPresse.key)
          || this.parametresInterne(PARAMETRES_INTERNE_KEYS.produitSalon.key)
          || this.parametresInterne(PARAMETRES_INTERNE_KEYS.produitAutre.key)
          || this.parametresInterne(PARAMETRES_INTERNE_KEYS.produitSponsoring.key)
          || this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleRegroupementProduit.key);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.prelevementSepa.key,
        PARAMETRES_INTERNE_KEYS.retrocessionAlfa.key,
        PARAMETRES_INTERNE_KEYS.moduleFactor.key,
        PARAMETRES_INTERNE_KEYS.modulePlanMedia.key,
        PARAMETRES_INTERNE_KEYS.importCommandeIdelia.key,
        PARAMETRES_INTERNE_KEYS.produitPresse.key,
        PARAMETRES_INTERNE_KEYS.campagne.key,
        PARAMETRES_INTERNE_KEYS.moduleRegroupementProduit.key,
        PARAMETRES_INTERNE_KEYS.produitSponsoring.key,
        PARAMETRES_INTERNE_KEYS.produitAutre.key,
        PARAMETRES_INTERNE_KEYS.produitSalon.key,
        PARAMETRES_INTERNE_KEYS.moduleProduitReseauNumerique.key,
        PARAMETRES_INTERNE_KEYS.moduleEcranNumerique.key,
        PARAMETRES_INTERNE_KEYS.moduleProduitFaceUnitaire.key,
        PARAMETRES_INTERNE_KEYS.moduleProduitReseauLc.key,
        PARAMETRES_INTERNE_KEYS.moduleProduitReseauTempo.key,
      ]);
      this.gescomMenu = this.getGescomMenu();
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw (e);
    }
  },
};
</script>

<style scoped>

</style>
